export const STAGES = [
  { id: 'sourcing', label: 'Sourcing', color: '#64748b', bg: 'rgba(100,116,139,0.1)', border: 'rgba(100,116,139,0.3)', headerBg: '#f1f5f9' },
  { id: 'screening', label: 'Screening', color: '#2563eb', bg: 'rgba(37,99,235,0.1)', border: 'rgba(37,99,235,0.3)', headerBg: '#eff6ff' },
  { id: 'diligence', label: 'Diligence', color: '#7c3aed', bg: 'rgba(124,58,237,0.1)', border: 'rgba(124,58,237,0.3)', headerBg: '#f5f3ff' },
  { id: 'ic-review', label: 'IC Review', color: '#d97706', bg: 'rgba(217,119,6,0.1)', border: 'rgba(217,119,6,0.3)', headerBg: '#fffbeb' },
  { id: 'execution', label: 'Execution', color: '#059669', bg: 'rgba(5,150,105,0.1)', border: 'rgba(5,150,105,0.3)', headerBg: '#ecfdf5' },
  { id: 'asset-mgmt', label: 'Asset Management', color: '#0891b2', bg: 'rgba(8,145,178,0.1)', border: 'rgba(8,145,178,0.3)', headerBg: '#ecfeff' },
];

export const SECTORS = [
  { id: 'energy', label: 'Energy', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  { id: 'transport', label: 'Transport', color: '#3b82f6', bg: 'rgba(59,130,246,0.12)' },
  { id: 'digital', label: 'Digital Infrastructure', color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)' },
  { id: 'water', label: 'Water', color: '#06b6d4', bg: 'rgba(6,182,212,0.12)' },
  { id: 'social', label: 'Social Infrastructure', color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
];

export const RISK_CONFIG = {
  Low: { color: '#059669', bg: 'rgba(5,150,105,0.1)', border: 'rgba(5,150,105,0.3)' },
  Medium: { color: '#d97706', bg: 'rgba(217,119,6,0.1)', border: 'rgba(217,119,6,0.3)' },
  High: { color: '#dc2626', bg: 'rgba(220,38,38,0.1)', border: 'rgba(220,38,38,0.3)' },
};

export const DEALS = [
  {
    id: 'deal-1',
    name: 'East Anglia Carbon Capture',
    sector: 'energy',
    region: 'East Anglia, UK',
    stage: 'sourcing',
    fundId: 'fund-2',
    targetIRR: 14.2,
    ticketSize: 75,
    riskRating: 'High',
    dateAdded: '2026-01-10',
    daysInStage: 24,
    assignedTo: 'SM',
    assignedName: 'Sarah Mitchell',
    lastActivity: '2026-03-01',
    flagged: false,
    description: 'Carbon capture and storage facility in East Anglia targeting industrial emitters. Early-stage prospect at sourcing.',
    originatorContext: null,
  },
  {
    id: 'deal-2',
    name: 'Iberian Battery Storage Complex',
    sector: 'energy',
    region: 'Spain',
    stage: 'sourcing',
    fundId: 'fund-2',
    targetIRR: 13.8,
    ticketSize: 90,
    riskRating: 'Medium',
    dateAdded: '2026-01-22',
    daysInStage: 12,
    assignedTo: 'CR',
    assignedName: 'Carlos Reyes',
    lastActivity: '2026-02-28',
    flagged: false,
    description: 'Large-scale battery energy storage complex in Spain, co-located with existing solar assets. New prospect at sourcing stage.',
    originatorContext: null,
  },
  {
    id: 'deal-3',
    name: 'Elbe Biomass Plant',
    sector: 'energy',
    region: 'Germany',
    stage: 'screening',
    fundId: 'fund-2',
    targetIRR: 11.3,
    ticketSize: 57,
    riskRating: 'Medium',
    dateAdded: '2025-12-15',
    daysInStage: 31,
    assignedTo: 'KW',
    assignedName: 'Klaus Weber',
    lastActivity: '2026-02-25',
    flagged: false,
    description: 'Biomass energy plant in Germany currently in construction. Recently screened — In Construction stage.',
    originatorContext: null,
  },
  {
    id: 'deal-5',
    name: 'Nordic Fibre Network Phase II',
    sector: 'digital',
    region: 'Sweden',
    stage: 'diligence',
    fundId: 'fund-2',
    targetIRR: 15.2,
    ticketSize: 41,
    riskRating: 'Low',
    dateAdded: '2025-10-20',
    daysInStage: 38,
    assignedTo: 'EL',
    assignedName: 'Erik Lindqvist',
    lastActivity: '2026-03-02',
    flagged: false,
    description: 'Follow-on opportunity linked to the operational Nordic Fibre Network asset. Phase II expansion across Sweden.',
    originatorContext: null,
  },
  {
    id: 'deal-7',
    name: 'Tyne Bridge Refinancing',
    sector: 'transport',
    region: 'North East England',
    stage: 'ic-review',
    fundId: 'fund-2',
    targetIRR: 7.2,
    ticketSize: 120,
    riskRating: 'Low',
    dateAdded: '2025-09-12',
    daysInStage: 14,
    assignedTo: 'TH',
    assignedName: 'Tom Hargreaves',
    lastActivity: '2026-04-10',
    flagged: true,
    description: 'Refinancing of the operational Tyne Bridge toll road concession for Fund II. IC submission lodged — committee meeting 13 April. SPV in pre-formation; anchor investors soft-circled.',
    originatorContext: null,
  },
  {
    id: 'deal-8',
    name: 'Solano Wind Infrastructure',
    sector: 'energy',
    region: 'Spain',
    stage: 'asset-mgmt',
    fundId: 'fund-1',
    targetIRR: 12.4,
    ticketSize: 85,
    riskRating: 'Low',
    dateAdded: '2025-07-18',
    daysInStage: 267,
    assignedTo: 'CR',
    assignedName: 'Carlos Reyes',
    lastActivity: '2026-04-07',
    flagged: false,
    description: 'Onshore wind farm in Spain. Fully deployed in Fund I with Apex Infrastructure Partners as GP co-investor (£15m). Capital deployed, SPV operational, Q1 2026 capital call issued.',
    originatorContext: null,
  },
  {
    id: 'deal-11',
    name: 'Lagos Solar Platform — Phase I',
    sector: 'energy',
    region: 'Lagos, Nigeria',
    stage: 'sourcing',
    fundId: 'fund-2',
    targetIRR: 14.5,
    ticketSize: 45,
    riskRating: 'High',
    dateAdded: '2026-04-04',
    daysInStage: 7,
    assignedTo: 'JH',
    assignedName: 'James Harrison',
    lastActivity: '2026-04-04',
    flagged: false,
    description: 'Utility-scale solar PV platform targeting commercial and industrial offtakers in Lagos State. Phase I capacity of 50MW with grid-tied and embedded network configurations. Submitted via deal originator channel.',
    originatorContext: 'ctx-deal-originator',
  },
  {
    id: 'deal-12',
    name: 'Kano Wind Corridor',
    sector: 'energy',
    region: 'Kano, Nigeria',
    stage: 'screening',
    fundId: 'fund-2',
    targetIRR: 13.8,
    ticketSize: 32,
    riskRating: 'High',
    dateAdded: '2026-03-23',
    daysInStage: 19,
    assignedTo: 'SM',
    assignedName: 'Sarah Mitchell',
    lastActivity: '2026-03-28',
    flagged: false,
    description: 'Onshore wind development in Kano State targeting 40MW initial capacity. Early-stage technical feasibility completed. Wind resource data available. Submitted via deal originator channel.',
    originatorContext: 'ctx-deal-originator',
  },
];

export const TENDER_STATUS_CONFIG = {
  Draft: { color: '#64748b', bg: 'rgba(100,116,139,0.1)', border: 'rgba(100,116,139,0.3)' },
  Open: { color: '#2563eb', bg: 'rgba(37,99,235,0.1)', border: 'rgba(37,99,235,0.3)' },
  Evaluation: { color: '#d97706', bg: 'rgba(217,119,6,0.1)', border: 'rgba(217,119,6,0.3)' },
  Awarded: { color: '#059669', bg: 'rgba(5,150,105,0.1)', border: 'rgba(5,150,105,0.3)' },
  Cancelled: { color: '#dc2626', bg: 'rgba(220,38,38,0.1)', border: 'rgba(220,38,38,0.3)' },
};

export const CATEGORY_CONFIG = {
  Construction: { color: '#7c3aed', bg: 'rgba(124,58,237,0.1)' },
  Supply: { color: '#0891b2', bg: 'rgba(8,145,178,0.1)' },
  Services: { color: '#059669', bg: 'rgba(5,150,105,0.1)' },
  Consultancy: { color: '#d97706', bg: 'rgba(217,119,6,0.1)' },
};

export const WORK_PACKAGES = [
  {
    id: 'wp-1',
    name: 'Civil & Structural Works',
    associatedDeal: 'deal-3',
    associatedDealName: 'Elbe Biomass Plant',
    category: 'Construction',
    estimatedValue: 42.5,
    tenderStatus: 'Evaluation',
    bidderCount: 4,
    awardDecision: 'Pending',
    targetAwardDate: '2026-04-15',
    description: 'Civil and structural works for the biomass plant facility, including foundations, steel frame, and external envelope.',
    procurementLead: 'Klaus Weber',
    tenderIssueDate: '2026-01-10',
    submissionDeadline: '2026-02-28',
    evaluationPeriod: '2026-03-01 to 2026-04-10',
    awardDate: null,
    notes: 'Three bidders have submitted compliant tenders. One bidder withdrew. Evaluation in progress.',
    bidders: [
      { id: 'b1', name: 'Balfour Beatty Infrastructure', type: 'Contractor', submissionStatus: 'Submitted', technicalScore: 88, commercialScore: 82, rank: 1, notes: 'Strong track record in biomass construction.' },
      { id: 'b2', name: 'Skanska UK Ltd', type: 'Contractor', submissionStatus: 'Submitted', technicalScore: 85, commercialScore: 79, rank: 2, notes: 'Competitive pricing, minor technical queries raised.' },
      { id: 'b3', name: 'Laing O Rourke', type: 'Contractor', submissionStatus: 'Submitted', technicalScore: 80, commercialScore: 85, rank: 3, notes: 'Lowest price but lower technical score.' },
      { id: 'b4', name: 'Kier Group', type: 'Contractor', submissionStatus: 'Withdrawn', technicalScore: null, commercialScore: null, rank: null, notes: 'Withdrew citing resource constraints.' },
    ],
    awardedBidder: null,
    awardValue: null,
    awardRationale: null,
    approver: null,
    approvalDate: null,
  },
  {
    id: 'wp-2',
    name: 'Electrical Equipment Supply',
    associatedDeal: 'deal-3',
    associatedDealName: 'Elbe Biomass Plant',
    category: 'Supply',
    estimatedValue: 18.0,
    tenderStatus: 'Open',
    bidderCount: 5,
    awardDecision: 'Pending',
    targetAwardDate: '2026-05-30',
    description: 'Supply of HV/LV switchgear, transformers, UPS systems, and standby generators for the biomass plant.',
    procurementLead: 'Klaus Weber',
    tenderIssueDate: '2026-02-15',
    submissionDeadline: '2026-04-01',
    evaluationPeriod: '2026-04-02 to 2026-05-20',
    awardDate: null,
    notes: 'Tender documents issued. Pre-qualification questionnaires received from 5 suppliers.',
    bidders: [
      { id: 'b5', name: 'Schneider Electric UK', type: 'Supplier', submissionStatus: 'Pending', technicalScore: null, commercialScore: null, rank: null, notes: 'Pre-qualified. Awaiting tender submission.' },
      { id: 'b6', name: 'ABB Ltd', type: 'Supplier', submissionStatus: 'Pending', technicalScore: null, commercialScore: null, rank: null, notes: 'Pre-qualified. Awaiting tender submission.' },
      { id: 'b7', name: 'Siemens Energy', type: 'Supplier', submissionStatus: 'Pending', technicalScore: null, commercialScore: null, rank: null, notes: 'Pre-qualified. Awaiting tender submission.' },
      { id: 'b8', name: 'Eaton Corporation', type: 'Supplier', submissionStatus: 'Pending', technicalScore: null, commercialScore: null, rank: null, notes: 'Pre-qualified. Awaiting tender submission.' },
      { id: 'b9', name: 'Legrand UK', type: 'Supplier', submissionStatus: 'Pending', technicalScore: null, commercialScore: null, rank: null, notes: 'Pre-qualified. Awaiting tender submission.' },
    ],
    awardedBidder: null,
    awardValue: null,
    awardRationale: null,
    approver: null,
    approvalDate: null,
  },
  {
    id: 'wp-4',
    name: 'Grid Connection Technical Advisory',
    associatedDeal: 'deal-8',
    associatedDealName: 'Solano Wind Farm',
    category: 'Consultancy',
    estimatedValue: 2.8,
    tenderStatus: 'Draft',
    bidderCount: 0,
    awardDecision: 'Pending',
    targetAwardDate: '2026-06-30',
    description: 'Technical advisory services for the Solano Wind Farm grid connection, including cable route survey, substation design review, and REE interface management.',
    procurementLead: 'Carlos Reyes',
    tenderIssueDate: null,
    submissionDeadline: null,
    evaluationPeriod: null,
    awardDate: null,
    notes: 'Scope of services under development. Longlist of consultants being prepared.',
    bidders: [],
    awardedBidder: null,
    awardValue: null,
    awardRationale: null,
    approver: null,
    approvalDate: null,
  },
];
